import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import DailyAppointment from '@/types/table/dailyAppointment';
import { DailyAppointmentDetailData } from '@/api/generated/dailyAppointmentDetailController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface DailyAppointmentData extends DailyAppointment {
  dailyAppointmentDetailList?: DailyAppointmentDetailData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class DailyAppointmentController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<DailyAppointmentData>>(API_CONTEXT + '/app/dailyAppointment/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<DailyAppointmentData>(API_CONTEXT + '/app/dailyAppointment/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/dailyAppointment/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/dailyAppointment/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/dailyAppointment/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointment/add', params, httpOptions);
  }
  static batchAdd(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointment/batchAdd', params, httpOptions);
  }


  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointment/update', params, httpOptions);
  }

  static updateStatus(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointment/updateStatus', params, httpOptions);
  }


  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointment/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointment/deleteBatch', params, httpOptions);
  }
}
